module.exports = __webpack_public_path__ + "img/data-view-ai-usage.cd81d86c.svg";